const extractYouTubeId = (url = "") => {
  try {
    const parsed = new URL(url);
    if (parsed.hostname.includes("youtu.be")) {
      return parsed.pathname.replace("/", "");
    }
    if (parsed.pathname.includes("/shorts/")) {
      return parsed.pathname.split("/shorts/")[1]?.split("/")[0] || "";
    }
    if (parsed.pathname.includes("/embed/")) {
      return parsed.pathname.split("/embed/")[1]?.split("/")[0] || "";
    }
    return parsed.searchParams.get("v") || "";
  } catch {
    return "";
  }
};

export const getYouTubeEmbedUrl = (url, autoplay = false) => {
  const videoId = extractYouTubeId(url);
  if (!videoId) {
    return "";
  }

  const autoplayQuery = autoplay ? "1" : "0";
  return `https://www.youtube.com/embed/${videoId}?autoplay=${autoplayQuery}&rel=0&modestbranding=1`;
};

export const isVerticalStory = (story) => ["short", "story", "reel"].includes(story?.content_type);